import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import logoImage from '../assets/image/cherma8.jpg';

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="header">
   
      <div className="header__container">
        <div className="header__top">
          <div className="header__logo-wrapper">
            <div className="header__logo-icon">
             <img src={logoImage} style={{ width: "40px" }} />

            </div>
            <h1 className="header__logo-text">{t('temple.name')}</h1>
          </div>

          <div className="header__right">
            {/* Language Tabs */}
            <div className="header__lang-tabs">
              <button
                onClick={() => setLanguage('en')}
                className={language === 'en' ? 'active' : ''}
               disabled
              >
                EN
              </button>
              <button
                onClick={() => setLanguage('ta')}
                className={language === 'ta' ? 'active' : ''}
              >
                தமிழ்
              </button>
            </div>

            {/* Desktop Navigation */}
            <nav className="header__nav">
              <button onClick={() => scrollToSection('home')}>
                {t('nav.home')}
              </button>
              <button onClick={() => scrollToSection('about')}>
                {t('nav.about')}
              </button>
              <button onClick={() => scrollToSection('services')}>
                {t('nav.services')}
              </button> 
              <button onClick={() => scrollToSection('gallery')}>
                {t('nav.gallery')}
              </button>
              <button onClick={() => scrollToSection('contact')}>
                {t('nav.contact')}
              </button>
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="header__mobile-menu-btn"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
        <div class="scroll-text">
          <p>{ t('header.text')}</p>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="header__mobile-nav">
            <button onClick={() => scrollToSection('home')}>
              {t('nav.home')}
            </button>
            <button onClick={() => scrollToSection('about')}>
              {t('nav.about')}
            </button>
            <button onClick={() => scrollToSection('services')}>
              {t('nav.services')}
            </button>
            <button onClick={() => scrollToSection('gallery')}>
              {t('nav.gallery')}
            </button>
            <button onClick={() => scrollToSection('contact')}>
              {t('nav.contact')}
            </button>
          </nav>
        )}
      </div>
   
    </header>
  
    
  );
}
